var map = {
	"./en": 303,
	"./en-GB": 313,
	"./en-GB.js": 313,
	"./en-IE": 314,
	"./en-IE.js": 314,
	"./en-US": 312,
	"./en-US.js": 312,
	"./en.js": 303
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 460;
module.exports = webpackAsyncContext;